import { render, staticRenderFns } from "./CreateReferentPassword.vue?vue&type=template&id=f2f50248&"
import script from "./CreateReferentPassword.vue?vue&type=script&lang=js&"
export * from "./CreateReferentPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports